export enum BookingCannotBeRemovedReason {
  HasInvoiceNumber = "HasInvoiceNumber",
  ConsultantPaid = "ConsultantPaid",
  CustomerBilled = "CustomerBilled",
  AccommodationBenefitTax = "AccommodationBenefitTax",
  TimereportNotBlank = "TimereportNotBlank"
}
